module.exports = __webpack_public_path__ + "static/media/main1_zh_768-min.061e4e16.png";